export enum Privilege {
  CANVAS_SETTING_EDIT = 'canvas.canvasSettings.edit',
  CANVAS_CLOSE_ROOMS_EDIT = 'canvas.closedRooms.edit',

  GUEST_ADD = 'guests.add',
  GUEST_EDIT = 'guests.edit',
  GUEST_REMOVE = 'guests.remove',

  COMPANY_ADD = 'partners.add',
  COMPANY_EDIT = 'partners.edit',
  COMPANY_REMOVE = 'partners.remove',

  CONTACT_PERSON_ADD = 'contactPersons.add',
  CONTACT_PERSON_EDIT = 'contactPersons.edit',
  CONTACT_PERSON_REMOVE = 'contactPersons.delete',

  PAYMENT_ADD = 'payments.add',
  PAYMENT_REMOVE = 'payments.remove',
  PAYMENT_CHANGE_DATE = 'payments.issueDate.change',

  DOCUMENT_ADD = 'invoices.add',
  DOCUMENT_ADD_INVOICE = 'invoices.add.1',
  DOCUMENT_ADD_RECEIPT = 'invoices.add.2',
  DOCUMENT_ADD_PROFORMA = 'invoices.add.3',
  DOCUMENT_ADD_ADVANCE_PAYMENT_DOCUMENT = 'invoices.add.4',
  DOCUMENT_ADD_COUPON = 'invoices.add.5',
  DOCUMENT_ADD_CREDIT_NOTE = 'invoices.add.6',

  DOCUMENT_EDIT = 'invoices.edit',
  DOCUMENT_EDIT_INVOICE = 'invoices.edit.1',
  DOCUMENT_EDIT_RECEIPT = 'invoices.edit.2',
  DOCUMENT_EDIT_PROFORMA = 'invoices.edit.3',
  DOCUMENT_EDIT_ADVANCE_PAYMENT_DOCUMENT = 'invoices.edit.4',
  DOCUMENT_EDIT_COUPON = 'invoices.edit.5',
  DOCUMENT_EDIT_CREDIT_NOTE = 'invoices.edit.6',

  DOCUMENT_REMOVE = 'invoices.remove',
  DOCUMENT_REMOVE_INVOICE = 'invoices.remove.1',
  DOCUMENT_REMOVE_RECEIPT = 'invoices.remove.2',
  DOCUMENT_REMOVE_PROFORMA = 'invoices.remove.3',
  DOCUMENT_REMOVE_ADVANCE_PAYMENT_DOCUMENT = 'invoices.remove.4',
  DOCUMENT_REMOVE_COUPON = 'invoices.remove.5',
  DOCUMENT_REMOVE_CREDIT_NOTE = 'invoices.remove.6',

  DOCUMENT_FISCALIZATION_CANCEL = 'invoices.edit.registeredInvoice.storno',
  DOCUMENT_FISCALIZATION_CANCEL_INVOICE = 'invoices.edit.registeredInvoice.storno.1',
  DOCUMENT_FISCALIZATION_CANCEL_RECEIPT = 'invoices.edit.registeredInvoice.storno.2',
  DOCUMENT_FISCALIZATION_CANCEL_PROFORMA = 'invoices.edit.registeredInvoice.storno.3',
  DOCUMENT_FISCALIZATION_CANCEL_ADVANCE_PAYMENT_DOCUMENT = 'invoices.edit.registeredInvoice.storno.4',
  DOCUMENT_FISCALIZATION_CANCEL_COUPON = 'invoices.edit.registeredInvoice.storno.5',
  DOCUMENT_FISCALIZATION_CANCEL_CREDIT_NOTE = 'invoices.edit.registeredInvoice.storno.6',

  OFFER_ADD = 'offers.add',

  RESERVATION_ADD = 'reservations.add',
  RESERVATION_ADD_1 = 'reservations.add.1',
  RESERVATION_ADD_2 = 'reservations.add.2',
  RESERVATION_ADD_3 = 'reservations.add.3',
  RESERVATION_ADD_6 = 'reservations.add.6',
  RESERVATION_ADD_7 = 'reservations.add.7',
  RESERVATION_ADD_8 = 'reservations.add.8',
  RESERVATION_ADD_9 = 'reservations.add.9',
  RESERVATION_ADD_10 = 'reservations.add.10',

  RESERVATION_EDIT = 'reservations.edit',
  RESERVATION_EDIT_1 = 'reservations.edit.1',
  RESERVATION_EDIT_2 = 'reservations.edit.2',
  RESERVATION_EDIT_3 = 'reservations.edit.3',
  RESERVATION_EDIT_6 = 'reservations.edit.6',
  RESERVATION_EDIT_7 = 'reservations.edit.7',
  RESERVATION_EDIT_8 = 'reservations.edit.8',
  RESERVATION_EDIT_9 = 'reservations.edit.9',
  RESERVATION_EDIT_10 = 'reservations.edit.10',

  RESERVATION_REMOVE = 'reservations.remove',
  RESERVATION_REMOVE_1 = 'reservations.remove.1',
  RESERVATION_REMOVE_2 = 'reservations.remove.2',
  RESERVATION_REMOVE_3 = 'reservations.remove.3',
  RESERVATION_REMOVE_6 = 'reservations.remove.6',
  RESERVATION_REMOVE_7 = 'reservations.remove.7',
  RESERVATION_REMOVE_8 = 'reservations.remove.8',
  RESERVATION_REMOVE_9 = 'reservations.remove.9',
  RESERVATION_REMOVE_10 = 'reservations.remove.10',

  RESERVATIONS_EDIT_CHANGE_STATUS = 'reservations.edit.changeStatus',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_2 = 'reservations.edit.changeStatus.1.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_3 = 'reservations.edit.changeStatus.1.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_6 = 'reservations.edit.changeStatus.1.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_7 = 'reservations.edit.changeStatus.1.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_8 = 'reservations.edit.changeStatus.1.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_9 = 'reservations.edit.changeStatus.1.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_1_10 = 'reservations.edit.changeStatus.1.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_2_1 = 'reservations.edit.changeStatus.2.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_3 = 'reservations.edit.changeStatus.2.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_6 = 'reservations.edit.changeStatus.2.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_7 = 'reservations.edit.changeStatus.2.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_8 = 'reservations.edit.changeStatus.2.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_9 = 'reservations.edit.changeStatus.2.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_2_10 = 'reservations.edit.changeStatus.2.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_3_1 = 'reservations.edit.changeStatus.3.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_2 = 'reservations.edit.changeStatus.3.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_6 = 'reservations.edit.changeStatus.3.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_7 = 'reservations.edit.changeStatus.3.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_8 = 'reservations.edit.changeStatus.3.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_9 = 'reservations.edit.changeStatus.3.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_3_10 = 'reservations.edit.changeStatus.3.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_6_1 = 'reservations.edit.changeStatus.6.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_2 = 'reservations.edit.changeStatus.6.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_3 = 'reservations.edit.changeStatus.6.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_7 = 'reservations.edit.changeStatus.6.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_8 = 'reservations.edit.changeStatus.6.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_9 = 'reservations.edit.changeStatus.6.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_6_10 = 'reservations.edit.changeStatus.6.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_7_1 = 'reservations.edit.changeStatus.7.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_2 = 'reservations.edit.changeStatus.7.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_3 = 'reservations.edit.changeStatus.7.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_6 = 'reservations.edit.changeStatus.7.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_8 = 'reservations.edit.changeStatus.7.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_9 = 'reservations.edit.changeStatus.7.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_7_10 = 'reservations.edit.changeStatus.7.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_8_1 = 'reservations.edit.changeStatus.8.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_2 = 'reservations.edit.changeStatus.8.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_3 = 'reservations.edit.changeStatus.8.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_6 = 'reservations.edit.changeStatus.8.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_7 = 'reservations.edit.changeStatus.8.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_9 = 'reservations.edit.changeStatus.8.9',
  RESERVATIONS_EDIT_CHANGE_STATUS_8_10 = 'reservations.edit.changeStatus.8.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_9_1 = 'reservations.edit.changeStatus.9.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_2 = 'reservations.edit.changeStatus.9.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_3 = 'reservations.edit.changeStatus.9.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_6 = 'reservations.edit.changeStatus.9.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_7 = 'reservations.edit.changeStatus.9.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_8 = 'reservations.edit.changeStatus.9.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_9_10 = 'reservations.edit.changeStatus.9.10',

  RESERVATIONS_EDIT_CHANGE_STATUS_10_1 = 'reservations.edit.changeStatus.10.1',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_2 = 'reservations.edit.changeStatus.10.2',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_3 = 'reservations.edit.changeStatus.10.3',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_6 = 'reservations.edit.changeStatus.10.6',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_7 = 'reservations.edit.changeStatus.10.7',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_8 = 'reservations.edit.changeStatus.10.8',
  RESERVATIONS_EDIT_CHANGE_STATUS_10_9 = 'reservations.edit.changeStatus.10.9',

  RESERVATIONS_EDIT_LOCK = 'reservations.edit.lockEditation',
  RESERVATIONS_EDIT_LOCK_1 = 'reservations.edit.lockEditation.1',
  RESERVATIONS_EDIT_LOCK_2 = 'reservations.edit.lockEditation.2',
  RESERVATIONS_EDIT_LOCK_3 = 'reservations.edit.lockEditation.3',
  RESERVATIONS_EDIT_LOCK_6 = 'reservations.edit.lockEditation.6',
  RESERVATIONS_EDIT_LOCK_7 = 'reservations.edit.lockEditation.7',
  RESERVATIONS_EDIT_LOCK_8 = 'reservations.edit.lockEditation.8',
  RESERVATIONS_EDIT_LOCK_9 = 'reservations.edit.lockEditation.9',
  RESERVATIONS_EDIT_LOCK_10 = 'reservations.edit.lockEditation.10',

  RESERVATIONS_EDIT_UNLOCK = 'reservations.edit.unlockEditation',
  RESERVATIONS_EDIT_UNLOCK_1 = 'reservations.edit.unlockEditation.1',
  RESERVATIONS_EDIT_UNLOCK_2 = 'reservations.edit.unlockEditation.2',
  RESERVATIONS_EDIT_UNLOCK_3 = 'reservations.edit.unlockEditation.3',
  RESERVATIONS_EDIT_UNLOCK_6 = 'reservations.edit.unlockEditation.6',
  RESERVATIONS_EDIT_UNLOCK_7 = 'reservations.edit.unlockEditation.7',
  RESERVATIONS_EDIT_UNLOCK_8 = 'reservations.edit.unlockEditation.8',
  RESERVATIONS_EDIT_UNLOCK_9 = 'reservations.edit.unlockEditation.9',
  RESERVATIONS_EDIT_UNLOCK_10 = 'reservations.edit.unlockEditation.10',

  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD = 'reservations.edit.hotelAccount.ownItem.add',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_1 = 'reservations.edit.hotelAccount.ownItem.add.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_2 = 'reservations.edit.hotelAccount.ownItem.add.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_3 = 'reservations.edit.hotelAccount.ownItem.add.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_6 = 'reservations.edit.hotelAccount.ownItem.add.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_7 = 'reservations.edit.hotelAccount.ownItem.add.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_8 = 'reservations.edit.hotelAccount.ownItem.add.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_9 = 'reservations.edit.hotelAccount.ownItem.add.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_OWN_ITEM_ADD_10 = 'reservations.edit.hotelAccount.ownItem.add.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD = 'reservations.edit.hotelAccount.itemFromWhisperer.add',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_1 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_2 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_3 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_6 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_7 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_8 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_9 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_FROM_WHISPERER_ADD_10 = 'reservations.edit.hotelAccount.itemFromWhisperer.add.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT = 'reservations.edit.hotelAccount.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_1 = 'reservations.edit.hotelAccount.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_2 = 'reservations.edit.hotelAccount.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_3 = 'reservations.edit.hotelAccount.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_6 = 'reservations.edit.hotelAccount.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_7 = 'reservations.edit.hotelAccount.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_8 = 'reservations.edit.hotelAccount.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_9 = 'reservations.edit.hotelAccount.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_10 = 'reservations.edit.hotelAccount.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT = 'reservations.edit.hotelAccount.edit.itemName.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_1 = 'reservations.edit.hotelAccount.edit.itemName.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_2 = 'reservations.edit.hotelAccount.edit.itemName.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_3 = 'reservations.edit.hotelAccount.edit.itemName.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_6 = 'reservations.edit.hotelAccount.edit.itemName.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_7 = 'reservations.edit.hotelAccount.edit.itemName.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_8 = 'reservations.edit.hotelAccount.edit.itemName.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_9 = 'reservations.edit.hotelAccount.edit.itemName.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_NAME_EDIT_10 = 'reservations.edit.hotelAccount.edit.itemName.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT = 'reservations.edit.hotelAccount.edit.itemCount.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_1 = 'reservations.edit.hotelAccount.edit.itemCount.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_2 = 'reservations.edit.hotelAccount.edit.itemCount.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_3 = 'reservations.edit.hotelAccount.edit.itemCount.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_6 = 'reservations.edit.hotelAccount.edit.itemCount.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_7 = 'reservations.edit.hotelAccount.edit.itemCount.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_8 = 'reservations.edit.hotelAccount.edit.itemCount.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_9 = 'reservations.edit.hotelAccount.edit.itemCount.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_COUNT_EDIT_10 = 'reservations.edit.hotelAccount.edit.itemCount.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT = 'reservations.edit.hotelAccount.edit.itemPrice.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_1 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_2 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_3 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_6 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_7 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_8 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_9 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_PRICE_EDIT_10 = 'reservations.edit.hotelAccount.edit.itemPrice.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT = 'reservations.edit.hotelAccount.edit.itemVatRate.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_1 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_2 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_3 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_6 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_7 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_8 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_9 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_ITEM_VAT_RATE_EDIT_10 = 'reservations.edit.hotelAccount.edit.itemVatRate.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT = 'reservations.edit.hotelAccount.edit.segment.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_1 = 'reservations.edit.hotelAccount.edit.segment.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_2 = 'reservations.edit.hotelAccount.edit.segment.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_3 = 'reservations.edit.hotelAccount.edit.segment.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_6 = 'reservations.edit.hotelAccount.edit.segment.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_7 = 'reservations.edit.hotelAccount.edit.segment.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_8 = 'reservations.edit.hotelAccount.edit.segment.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_9 = 'reservations.edit.hotelAccount.edit.segment.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_SEGMENT_EDIT_10 = 'reservations.edit.hotelAccount.edit.segment.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT = 'reservations.edit.hotelAccount.edit.unit.edit',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_1 = 'reservations.edit.hotelAccount.edit.unit.edit.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_2 = 'reservations.edit.hotelAccount.edit.unit.edit.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_3 = 'reservations.edit.hotelAccount.edit.unit.edit.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_6 = 'reservations.edit.hotelAccount.edit.unit.edit.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_7 = 'reservations.edit.hotelAccount.edit.unit.edit.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_8 = 'reservations.edit.hotelAccount.edit.unit.edit.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_9 = 'reservations.edit.hotelAccount.edit.unit.edit.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_EDIT_UNIT_EDIT_10 = 'reservations.edit.hotelAccount.edit.unit.edit.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE = 'reservations.edit.hotelAccount.item.remove',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_1 = 'reservations.edit.hotelAccount.item.remove.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_2 = 'reservations.edit.hotelAccount.item.remove.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_3 = 'reservations.edit.hotelAccount.item.remove.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_6 = 'reservations.edit.hotelAccount.item.remove.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_7 = 'reservations.edit.hotelAccount.item.remove.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_8 = 'reservations.edit.hotelAccount.item.remove.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_9 = 'reservations.edit.hotelAccount.item.remove.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_ITEM_REMOVE_10 = 'reservations.edit.hotelAccount.item.remove.10',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE = 'reservations.edit.hotelAccount.invoicedItem.remove',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_1 = 'reservations.edit.hotelAccount.invoicedItem.remove.1',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_2 = 'reservations.edit.hotelAccount.invoicedItem.remove.2',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_3 = 'reservations.edit.hotelAccount.invoicedItem.remove.3',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_6 = 'reservations.edit.hotelAccount.invoicedItem.remove.6',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_7 = 'reservations.edit.hotelAccount.invoicedItem.remove.7',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_8 = 'reservations.edit.hotelAccount.invoicedItem.remove.8',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_9 = 'reservations.edit.hotelAccount.invoicedItem.remove.9',
  RESERVATIONS_EDIT_HOTEL_ACCOUNT_INVOICED_ITEM_REMOVE_10 = 'reservations.edit.hotelAccount.invoicedItem.remove.10',
  RESERVATIONS_EDIT_FOLIO_LOCK = 'reservations.edit.accountLock',
  RESERVATIONS_EDIT_FOLIO_LOCK_1 = 'reservations.edit.accountLock.1',
  RESERVATIONS_EDIT_FOLIO_LOCK_2 = 'reservations.edit.accountLock.2',
  RESERVATIONS_EDIT_FOLIO_LOCK_3 = 'reservations.edit.accountLock.3',
  RESERVATIONS_EDIT_FOLIO_LOCK_6 = 'reservations.edit.accountLock.6',
  RESERVATIONS_EDIT_FOLIO_LOCK_7 = 'reservations.edit.accountLock.7',
  RESERVATIONS_EDIT_FOLIO_LOCK_8 = 'reservations.edit.accountLock.8',
  RESERVATIONS_EDIT_FOLIO_LOCK_9 = 'reservations.edit.accountLock.9',
  RESERVATIONS_EDIT_FOLIO_LOCK_10 = 'reservations.edit.accountLock.10',

  RESERVATIONS_EDIT_NOTE_EDIT = 'reservations.edit.reservationNote.edit',
  RESERVATIONS_EDIT_NOTE_EDIT_1 = 'reservations.edit.reservationNote.edit.1',
  RESERVATIONS_EDIT_NOTE_EDIT_2 = 'reservations.edit.reservationNote.edit.2',
  RESERVATIONS_EDIT_NOTE_EDIT_3 = 'reservations.edit.reservationNote.edit.3',
  RESERVATIONS_EDIT_NOTE_EDIT_6 = 'reservations.edit.reservationNote.edit.6',
  RESERVATIONS_EDIT_NOTE_EDIT_7 = 'reservations.edit.reservationNote.edit.7',
  RESERVATIONS_EDIT_NOTE_EDIT_8 = 'reservations.edit.reservationNote.edit.8',
  RESERVATIONS_EDIT_NOTE_EDIT_9 = 'reservations.edit.reservationNote.edit.9',
  RESERVATIONS_EDIT_NOTE_EDIT_10 = 'reservations.edit.reservationNote.edit.10',

  RESERVATIONS_EDIT_ATTACHMENTS_ADD = 'reservations.edit.attachments.add',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_1 = 'reservations.edit.attachments.add.1',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_2 = 'reservations.edit.attachments.add.2',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_3 = 'reservations.edit.attachments.add.3',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_6 = 'reservations.edit.attachments.add.6',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_7 = 'reservations.edit.attachments.add.7',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_8 = 'reservations.edit.attachments.add.8',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_9 = 'reservations.edit.attachments.add.9',
  RESERVATIONS_EDIT_ATTACHMENTS_ADD_10 = 'reservations.edit.attachments.add.10',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE = 'reservations.edit.attachments.delete',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_1 = 'reservations.edit.attachments.delete.1',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_2 = 'reservations.edit.attachments.delete.2',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_3 = 'reservations.edit.attachments.delete.3',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_6 = 'reservations.edit.attachments.delete.6',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_7 = 'reservations.edit.attachments.delete.7',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_8 = 'reservations.edit.attachments.delete.8',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_9 = 'reservations.edit.attachments.delete.9',
  RESERVATIONS_EDIT_ATTACHMENTS_DELETE_10 = 'reservations.edit.attachments.delete.10',

  RESERVATIONS_EDIT_SHOW_CREDIT_CARD = 'reservations.edit.displayCreditCard',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_1 = 'reservations.edit.displayCreditCard.1',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_2 = 'reservations.edit.displayCreditCard.2',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_3 = 'reservations.edit.displayCreditCard.3',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_6 = 'reservations.edit.displayCreditCard.6',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_7 = 'reservations.edit.displayCreditCard.7',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_8 = 'reservations.edit.displayCreditCard.8',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_9 = 'reservations.edit.displayCreditCard.9',
  RESERVATIONS_EDIT_SHOW_CREDIT_CARD_10 = 'reservations.edit.displayCreditCard.10',

  HOUSEKEEPING_ROOM_ASSIGNMENTS_EDIT = 'housekeeping.roomAssignments.edit',
  HOUSEKEEPING_DEFECT_ADD = 'housekeeping.faults.add',
  HOUSEKEEPING_DEFECT_EDIT = 'housekeeping.faults.edit',
  HOUSEKEEPING_DEFECT_REMOVE = 'housekeeping.faults.remove',
  HOUSEKEEPING_CLEANING_CHANGE_TIDINESS = 'housekeeping.roomCleanliness.edit',
  HOUSEKEEPING_TASK_ADD = 'housekeeping.traces.add',
  HOUSEKEEPING_TASK_EDIT = 'housekeeping.traces.edit',
  HOUSEKEEPING_TASK_EDIT_STATUS = 'housekeeping.traces.editStatus',
  HOUSEKEEPING_TASK_REMOVE = 'housekeeping.traces.remove',
  HOUSEKEEPING_TASK_TEMPLATE_VIEW = 'housekeeping.taskTemplates',
  HOUSEKEEPING_TASK_TEMPLATE_ADD = 'housekeeping.taskTemplates.add',
  HOUSEKEEPING_TASK_TEMPLATE_EDIT = 'housekeeping.taskTemplates.edit',
  HOUSEKEEPING_TASK_TEMPLATE_REMOVE = 'housekeeping.taskTemplates.delete',

  PRICING_SETUP = 'prices-parent.prices.priceSetup.edit',

  DAILY_OVERVIEW_PRINT = 'dailyReports.dailyOverview.print',
}
